export const FV_ACTION_EDIT_ID = 'edit' as const
export const FV_ACTION_DELETE_ID = 'delete' as const
